module.exports = __webpack_public_path__ + "img/server02.eedc423c.jpg";